import { CommonModule } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { DiagnosticsModule } from './diagnostics/diagnostics.module';
import { ResourceManagementModule } from './resourceManagement/resourceManagement.module';
import { LiveMapModule } from './livemap/livemap.module';
import { TemperatureModule } from "@temperature/temperature.module";
import { ExploreModule } from "./insights/insights.module";
import { NpsModule } from "./nps/nps.module";

const privateComponents: Type<any>[] = [

];

const publicComponents: Type<any>[] = [

];

@NgModule({
    imports: [
        CommonModule,
        ResourceManagementModule,
        DiagnosticsModule,
        LiveMapModule,
        TemperatureModule,
        ExploreModule,
        NpsModule
    ],
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents],
    exports: [...publicComponents]
})
export class ComponentsModule {
    constructor() { }
}
